﻿import React from "react";
import { i18n } from "../../helpers/localisation-helpers";
import { useTypedSelector } from "../../hooks/useTypeSelector";
import ExpertReview from "./ExpertReview";


const ExpertReviews = () => {
    const { productData } = useTypedSelector((state) => state.product);
    const [expandReviews, setExpandReviews] = React.useState<boolean>(false);

    const handleExpandReviews = () => {
        setExpandReviews(!expandReviews);
    };

    return (
        <>
            <div className="onepcssgrid-1300" style={{ overflow: "hidden" }}>
                <div className="onerow">
                    <div className="col12 last">
                        <div className="expert-reviews">
                            <a id="reviews"></a>
                            <div className="reviews">
                                <h2>
                                    {i18n("Resource.Reviews", productData.PageLocalisations)}
                                </h2>
                                {productData.ExpertReviews.map((review, index) => {
                                    return (
                                        <ExpertReview
                                            key={index}
                                            reviewUrl={review.Url}
                                            itemIndex={index + 1}
                                            fullImagePath={review.FullImagePath}
                                            text={review.Text}
                                            title={review.Title}
                                            publishDateFormatted={review.PublishDateFormatted}
                                            expandReviews={expandReviews}
                                        />
                                    )
                                })}

                                {productData.ExpertReviews.length > 3 && <div className="expanderbuttoncontainer">
                                    <a onClick={() => handleExpandReviews()} className="btn expander">{!expandReviews ? "Show more" : "Show less"}</a>
                                </div>}

                            </div>
                        </div>
  

                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpertReviews;